import Repo from './Repo.js'

export default class RecordBookTypeRepository extends Repo {
  constructor () {
    super('record-book-types')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id) {
    return super.get(id)
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
    return super.paginate(q)
  }

  fetchNumber (id) {
    return this.http.get(this.resource + '/' + id + '/number').then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
}
